import _ from "lodash";

import React, {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import {
  Link,
} from "react-router-dom";
import {
  withLocation,
} from "CommonCore/router-util";
import store from "CommonState/store";
import Breadcrumb from "CommonComponents/breadcrumb";
import {
  massnahmevorgesehenApi,
  schemaMassnahme,
} from "Apis/massnahme-api";
import antragApi from "Apis/antrag-api";
import EntityTable from "CommonComponents/entity-table";
import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import AntragAnnehmenPopup from "App/antrag-annehmen-popup";
import {
  createUiListSelector,
  derived,
} from "CommonState/action-helpers";
import {
  getModus,
} from "App/antragsteller-modus";
import {
  ANTRAGSTELLERMODUS,
} from "App/constants";

const TableRenderMethods = {
  m_bez: (item, obj) => obj && <Link to={ "/massnahmevorgesehen/" + obj.m_id }>{ item }</Link>,
};

const injects = injectsFromSchemaAndRenderMethods(massnahmevorgesehenApi.schema, TableRenderMethods);
const selectInjects = createInjectsSelector(injects);

// Für den aktuell angemeldeten Nutzer/Antragsteller vorgesehene Maßnahmen

// Selector für Massnahmen zum Antragstellermodus
const massnahmeModusUiListSelector = createUiListSelector("massnahmeModusList", schemaMassnahme, derived(
  "massnahmeModus",
  state => state.massnahmevorgesehenList,
  state => state.flag_antragstellermodus,
  (list, modus) => {
    return list && modus && ANTRAGSTELLERMODUS[modus].filterMassnahmen(list);
  },
));

@withLocation
@store(...injects, "massnahmetyp", "user", massnahmeModusUiListSelector, "flag_antragstellermodus")
@massnahmevorgesehenApi.noCache
@massnahmevorgesehenApi.list
@antragApi.actions
export default class MnVorgesehenListPage extends Component {
  constructor() {
    super();
    this.state = {
      edits: {},
      roleType: undefined,
    };
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus) {
      await getModus(this.props);
    }
  }

  render() {
    const {
      uiMassnahmeModusList,
      route,
      flag_antragstellermodus,
    } = this.props;
    const {
      modeAnnehmen,
    } = this.state;

    const toolbarComponents = <>
      <Button variant='primary' onClick={ this.startAnnehmen } disabled={ !(uiMassnahmeModusList && uiMassnahmeModusList.items.length > 0) }>Antrag stellen </Button>
    </>;

    const modus = ANTRAGSTELLERMODUS[flag_antragstellermodus];

    return <div>
      { modeAnnehmen && <AntragAnnehmenPopup
        AntragstellerModus={ flag_antragstellermodus } massnahmen={ uiMassnahmeModusList.items } onClose={ this.endAnnehmen} onAngenommen={ this.onAngenommen } />}
      <Breadcrumb name={`Für Sie ${ modus?.labelVorgesehene || "vorgesehene, geplante Einstellungen" }`} route={route} />
      <EntityTable
        list='massnahmeModusList'
        data={uiMassnahmeModusList}
        schema={massnahmevorgesehenApi.schema}
        renderMethods={TableRenderMethods}
        injects={_.assign(selectInjects(this.props), { flag_antragstellermodus })}
        toolbarComponents={toolbarComponents}
        actions={[
          {
            display: "Anzeigen",
            icon: "eye",
            execute: mn => `/massnahmevorgesehen/${ mn.m_id }`,
          },
        ]}

      />
    </div>;
  }

  endAnnehmen = () => {
    this.setState({ modeAnnehmen: false });
    // this.load()
  };
  startAnnehmen = () => {
    this.setState({ modeAnnehmen: true });
  };
  onAngenommen = a_id => {
    this.setState({ modeAnnehmen: false }, () => {
      this.props.clearAntragList(); // Service hat neuen Antrag angelegt
      this.props.history.push(`/antrag/${ a_id }`);
    });
  };
}

@withLocation
export class GoToButton extends React.Component {
  render() {
    const {
      name,
    } = this.props;
    return <Button variant='outline-primary' onClick={this.navigate}>
      {name}
    </Button>;
  }
  navigate = () => {
    const { history, to } = this.props;
    history.push(to);
  };
}
